var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulkContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.358 9.33268H21.8913L14.2513 5.33268L5.58464 9.86602V22.666C4.11797 22.666 2.91797 21.466 2.91797 19.9993V9.55935C2.91797 8.85268 3.34464 8.10602 3.98464 7.77268L14.2513 2.66602L24.3046 7.77268C24.878 8.07935 25.278 8.70602 25.358 9.33268ZM26.918 10.666H9.58463C8.11797 10.666 6.91797 11.866 6.91797 13.3327V25.3327C6.91797 26.7993 8.11797 27.9993 9.58463 27.9993H26.918C28.3846 27.9993 29.5846 26.7993 29.5846 25.3327V13.3327C29.5846 11.866 28.3846 10.666 26.918 10.666ZM26.918 15.5593L18.2513 19.9993L9.58463 15.5593V13.3327L18.2513 17.7727L26.918 13.3327V15.5593Z",
    fill: "#2E2B2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkContact);
export default __webpack_public_path__ + "static/media/bulkContact.ce68075fed6aade598d65d9e7d0b1746.svg";
export { ForwardRef as ReactComponent };